import * as Sentry from '@sentry/browser'
import { getModuleName } from '../../../logic/token'

export default {
  // サーバーからトークンを取得
  login({ commit }, { credentials, provider }) {
    const { username, password } = credentials

    const requestBody = {
      username,
      password,
      provider,
      grant_type: 'password',
      client_id: 2,
      client_secret: process.env.MIX_OAUTH_CLIENT_SECRET,
    }

    return window.axios.post('/oauth/token', requestBody)
      .then(({ data }) => data.access_token)
      .then((token) => {
        // axiosのヘッダーを更新
        window.axios.defaults.headers.common.Authorization = `Bearer ${token}`

        commit('addToken', token)

        return token
      })
  },

  // サーバーで保存されているトークンを削除
  logout({ commit }) {
    return window.axios.delete('/oauth/token')
      .then((res) => {
        commit('removeToken')
        commit('updateAuth', {})

        return res
      })
  },

  // サーバー経由の認証チェック
  check({ commit }, { to }) {
    return window.axios.get(`/api/${getModuleName()}/user?to=${to}`)
      .then((res) => {
        commit('updateAuth', res.data)
        const { email, name, company } = res.data
        Sentry.setUser({ email, name, company })
        return res
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          commit('removeToken')
          commit('updateAuth', {})
        }
        Sentry.captureException(err)

        throw err
      })
  },

  tokenLogin({ commit }, { token }) {
    commit('addToken', token)
  },
}
